import { useTranslation } from '@/i18n';
import { ButtonV2, ButtonV2Size } from '@moneyforward/ap-frontend-components';
import { FC, memo, useCallback, useState } from 'react';

type Props = {
  onClick: () => Promise<void>;
  size: ButtonV2Size;
  isDisabled?: boolean;
};

export const DeleteButton: FC<Props> = memo(
  ({ onClick: _onClick, size, isDisabled }) => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const onClick = useCallback(async () => {
      setIsLoading(true);
      try {
        await _onClick();
      } catch (error) {
        setIsLoading(false);
      } finally {
        setIsLoading(false);
      }
    }, [_onClick]);
    return (
      <ButtonV2
        color='danger'
        isSecondary
        size={size}
        onClick={onClick}
        isLoading={isLoading}
        isDisabled={isDisabled}
      >
        {t('delete')}
      </ButtonV2>
    );
  }
);
DeleteButton.displayName = 'DeleteButton';
